import {
  all,
  call,
  put,
  takeEvery,
  takeLatest,
  delay,
} from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  ADMIN_SLIDE_MACRO_REQUEST,
  ADMIN_SLIDE_MACRO_FAILURE,
  ADMIN_SLIDE_BARCODE_REQUEST,
  ADMIN_SLIDE_BARCODE_FAILURE,
  ADMIN_SLIDES_RUN_ACTION_REQUEST,
  ADMIN_SLIDES_RUN_ACTION_SUCCESS,
  ADMIN_SLIDES_RUN_ACTION_FAILURE,
  ADMIN_UPDATE_SLIDE_REQUEST,
  ADMIN_UPDATE_SLIDE_SUCCESS,
  ADMIN_UPDATE_SLIDE_CASES_FAILURE,
  ADMIN_UPDATE_SLIDE_FAILURE,
  ADMIN_DELETE_SLIDE_REQUEST,
  ADMIN_DELETE_SLIDE_SUCCESS,
  ADMIN_DELETE_SLIDE_FAILURE,
  ADMIN_SLIDE_BARCODE_SET,
  ADMIN_SLIDE_MACRO_SET,
} from "../actions/adminConstants";
import { addToast, nextId, removeToast } from "../actions/toastActions";

function* patchAdminSlide(action: any): any {
  try {
    const result = yield call(ApiService.partialUpdateAdminSlide, {
      id: action.payload.slide.id,
      requestBody: action.payload.slide,
    });
    yield put({ type: ADMIN_UPDATE_SLIDE_SUCCESS, payload: result });
    if (action.payload.navigate && action.payload.returnUrl) {
      action.payload.navigate(action.payload.returnUrl, { replace: true });
    }
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_SLIDE_CASES_FAILURE,
      payload: action.payload,
    });
    yield put({
      type: ADMIN_UPDATE_SLIDE_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* deleteAdminSlide(action: any): any {
  try {
    yield call(ApiService.destroySlide, {
      id: action.payload.slide_id,
      requestBody: action.payload,
    });
    const id: number = nextId();
    yield all([
      put(
        addToast(
          {
            kind: "success",
            title: "Deleted Slide",
            message: "Deleted slide successfully",
          },
          id
        )
      ),
      put({
        type: ADMIN_DELETE_SLIDE_SUCCESS,
        payload: action.payload,
      }),
    ]);
    if (action.payload.navigate && action.payload.returnUrl) {
      action.payload.navigate(action.payload.returnUrl, { replace: true });
    }
    yield delay(3000);
    yield put(removeToast(id));
  } catch (e) {
    yield put({
      type: ADMIN_DELETE_SLIDE_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* fetchBarcode(action: any): any {
  try {
    const result = yield call(ApiService.barcodeUrlSlide, {
      id: action.payload.slideId,
    });
    yield put({
      type: ADMIN_SLIDE_BARCODE_SET,
      payload: {
        url: {
          url: result.url || undefined,
          error: !result.url,
        },
        ...action.payload,
      },
    });
  } catch (e) {
    yield all([
      put({
        type: ADMIN_SLIDE_BARCODE_SET,
        payload: {
          url: {
            url: undefined,
            error: true,
          },
          ...action.payload,
        },
      }),
      put({
        type: ADMIN_SLIDE_BARCODE_FAILURE,
        error: false,
        payload: e,
      }),
    ]);
  }
}

function* fetchMacro(action: any): any {
  try {
    const result = yield call(ApiService.macroUrlSlide, {
      id: action.payload.slideId,
    });
    yield put({
      type: ADMIN_SLIDE_MACRO_SET,
      payload: {
        url: {
          url: result.url || undefined,
          error: !result.url,
        },
        ...action.payload,
      },
    });
  } catch (e) {
    yield all([
      put({
        type: ADMIN_SLIDE_MACRO_SET,
        payload: {
          url: {
            url: undefined,
            error: true,
          },
          ...action.payload,
        },
      }),
      put({
        type: ADMIN_SLIDE_MACRO_FAILURE,
        error: false,
        payload: e,
      }),
    ]);
  }
}

function* postAction(action: any): any {
  try {
    const result = yield call(ApiService.actionsAdminSlide, {
      requestBody: action.payload,
    });
    yield put({ type: ADMIN_SLIDES_RUN_ACTION_SUCCESS, payload: result });
  } catch (e) {
    yield put({
      type: ADMIN_SLIDES_RUN_ACTION_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* adminSlidesSaga() {
  yield takeEvery(ADMIN_UPDATE_SLIDE_REQUEST, patchAdminSlide);
  yield takeLatest(ADMIN_DELETE_SLIDE_REQUEST, deleteAdminSlide);
  yield takeLatest(ADMIN_SLIDES_RUN_ACTION_REQUEST, postAction);
  yield takeEvery(ADMIN_SLIDE_BARCODE_REQUEST, fetchBarcode);
  yield takeEvery(ADMIN_SLIDE_MACRO_REQUEST, fetchMacro);
}
